import { render, staticRenderFns } from "./ServiceSection.vue?vue&type=template&id=72bdb956&scoped=true&"
import script from "./ServiceSection.vue?vue&type=script&lang=js&"
export * from "./ServiceSection.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSection.vue?vue&type=style&index=0&id=72bdb956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bdb956",
  null
  
)

export default component.exports